import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { trigger, style, animate, transition, query, keyframes, state } from '@angular/animations';
interface cardItem{
	id:string,
	title:string,
  name:string,
	type:string,
	state:number,
	description?:string
}
// enum companyState{invalid=0,valid}
@Component({
	selector: 'component-solid-card',
	templateUrl: './component.html',
	styleUrls: ['./component.css']
})
export class ComponentSolidCard implements OnInit {

	@Input() cardList:cardItem[];
	@Input() assetsRoute: string;
	@Output() itemClick = new EventEmitter<any>();
	postData: any = {};
	constructor() {}
	handleItemClick(id, type){
    this.postData.id = id;
    this.postData.type = type;
    this.postData.isCloseWrap = false;
		this.itemClick.emit(this.postData);
	}
	ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/component-ui/solid-card/component.ts